export default __webpack_public_path__ + "18b75901c0db0799483b03ce7b458684.png";